import React from 'react';
import { forTemplate } from '@trello/i18n';
import styles from './EmptyBoardTableView.less';

const boardPlaceHolder = require('resources/images/empty-states/mbtv-empty-state-board-placeholder.svg');

const format = forTemplate('multi_board_table_view', {
  returnBlankForMissingStrings: true,
});

export const EmptyBoardTableView: React.FunctionComponent = () => (
  <div className={styles.empty}>
    <img
      src={boardPlaceHolder}
      className={styles.emptyBoardPlaceholder}
      alt=""
    />
    <div className={styles.message}>
      <h2 className={styles.heading}>{format('add-boards-to-create')}</h2>
      <div className={styles.subheading}>
        {format('your-team-table-can-help')}
      </div>
    </div>
  </div>
);
